import React, { useEffect } from 'react'
import { NavWrapper } from './style'
import { Button } from '../Button'
 
export const ChangeStructure = ({ activeStructure, changeStructure }) => {
    const changeActiveButtonHandler = e => {
        if (e.target.id === activeStructure) return
        changeStructure(e.target.id)
    }

    return (
        <NavWrapper>
            <Button active={activeStructure === 'fullStructure' ? true : false} id='fullStructure' onClick={changeActiveButtonHandler}>Полная структура</Button>
            {' '}
            <Button active={activeStructure === 'constructor' ? true : false} id='constructor' onClick={changeActiveButtonHandler}>Конструктор</Button>
        </NavWrapper>
    )
}
